import { render, staticRenderFns } from "./DisbursementTable.vue?vue&type=template&id=6f0e7d4e"
import script from "./DisbursementTable.vue?vue&type=script&lang=js"
export * from "./DisbursementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports